export function MedrecruitLogo({ medrecruitWebBaseUrl }: { medrecruitWebBaseUrl: string }) {
  return (
    <a href={medrecruitWebBaseUrl}>
      <img src="/medrecruit-logo.svg" alt="Medrecruit" className="h-[29px]" />
    </a>
  );
}
